// 導覽列 SVG 圖示集(取代原本的 Unicode 字形 ⌂▣◷✦◉◯,design review P1-2)。
// 線稿風、stroke=currentColor → 自動繼承 nav 連結的 active(primary)/未選(secondary)色;
// 24×24 viewBox,尺寸由 CSS `.app-nav a svg` 控制。aria-hidden(文字標籤已提供語意)。
import type { JSX } from 'react';

export type NavIconName = 'home' | 'devices' | 'events' | 'memories' | 'live' | 'account' | 'subscription';

const PATHS: Record<NavIconName, JSX.Element> = {
  // 房子
  home: (
    <>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5" />
      <path d="M9.5 21v-6h5v6" />
    </>
  ),
  // 攝影機(裝置)
  devices: (
    <>
      <rect x="3" y="6" width="13" height="12" rx="2" />
      <path d="M16 9.5l5-2.5v10l-5-2.5" />
    </>
  ),
  // 時鐘(事件時間軸)
  events: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </>
  ),
  // 星芒(精彩回顧)
  memories: (
    <>
      <path d="M12 3l1.9 5.6L19.5 10l-5.6 1.4L12 17l-1.9-5.6L4.5 10l5.6-1.4L12 3Z" />
      <path d="M18.5 15.5l.7 2 .8.7-.8.6-.7 2-.7-2-1-.6 1-.7Z" />
    </>
  ),
  // 廣播(即時)
  live: (
    <>
      <circle cx="12" cy="12" r="2.5" />
      <path d="M7.5 7.5a6 6 0 0 0 0 9M16.5 7.5a6 6 0 0 1 0 9" />
      <path d="M4.8 4.8a9.5 9.5 0 0 0 0 14.4M19.2 4.8a9.5 9.5 0 0 1 0 14.4" />
    </>
  ),
  // 人(帳號)
  account: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 20a7.5 7.5 0 0 1 15 0" />
    </>
  ),
  // 卡片(訂閱與方案)
  subscription: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 9.5h18" />
      <path d="M6.5 14.5h4" />
    </>
  ),
};

export function NavIcon({ name }: { name: NavIconName }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name]}
    </svg>
  );
}
